import React, { useState } from 'react';
import styles from './styles.module.scss';
import { toTitleCase } from 'utils/titleCase';
import { PdfViewerModal } from 'components/pdf-viewer';
import { formatWorkMode, shouldCollectJobLocation } from 'utils/workMode';

interface Responsibility {
  title: string;
  description: string;
}

interface Qualification {
  description: string;
}

interface JobData {
  jobTitle: string;
  organization: string;
  employmentType: string;
  work_mode?: string;
  location?: string;
  salaryRange: string;
  experience_level: string;
  experience_environment: string;
  salary_range_term: string;
  salary_range_currency: string;
  years_of_experience: string;
  responsibilities: Responsibility[];
  qualifications: Qualification[];
}

interface JobDescriptionProps {
  jdData?: JobData;
  onEdit?: (section: string) => void;
  pdfFile?: string;
}

const UploadedJobDescription: React.FC<JobDescriptionProps> = ({ jdData, pdfFile }) => {
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);

  const handleViewJD = () => {
    setIsPdfModalOpen(true);
  };

  const handleClosePdfModal = () => {
    setIsPdfModalOpen(false);
  };
  return (
    <>
      <div className={styles.jobDescriptionContainer}>
        <div className={styles.sectionContainer}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Job Description</h2>
          </div>
          <div className={styles.divider}></div>
        </div>

        <div className={styles.jobDetailsContainer}>
          <div className={styles.titleContainer}>
            <h3 className={styles.jobTitle}>{jdData?.jobTitle || "Untitled Job"}</h3>
          </div>

          <div className={styles.detailsRow}>
            <span className={styles.detailLabel}>Representing Organization:</span>
            <span className={styles.detailValue}>{jdData?.organization ? toTitleCase(jdData.organization) : "Not specified"}</span>
          </div>

          <div className={styles.detailsRow}>
            <span className={styles.detailLabel}>Employment type:</span>
            <span className={styles.detailValue}>{jdData?.employmentType ? toTitleCase(jdData.employmentType) : "Not specified"}</span>
          </div>

          {jdData?.work_mode && (
            <div className={styles.detailsRow}>
              <span className={styles.detailLabel}>Work mode:</span>
              <span className={styles.detailValue}>{formatWorkMode(jdData.work_mode)}</span>
            </div>
          )}

          {shouldCollectJobLocation(jdData?.work_mode) && jdData?.location && (
            <div className={styles.detailsRow}>
              <span className={styles.detailLabel}>Job location:</span>
              <span className={styles.detailValue}>{jdData.location}</span>
            </div>
          )}

          <div className={styles.detailsRow}>
            <span className={styles.detailLabel}>Salary range:</span>
            <span className={styles.detailValue}>{jdData?.salaryRange || "Not specified"}</span>
          </div>

          <div className={styles.detailsRow}>
            <span className={styles.detailLabel}>Duration of Salary:</span>
            <span className={styles.detailValue}>{jdData?.salary_range_term ? toTitleCase(jdData.salary_range_term) : "Not specified"}</span>
          </div>

          <div className={styles.detailsRow}>
            <span className={styles.detailLabel}>Currency of Salary:</span>
            <span className={styles.detailValue}>{jdData?.salary_range_currency || "Not specified"}</span>
          </div>

          <div className={styles.divider}></div>
        </div>
        <p className={styles.editMessage}>
          You can view the full job description using the link below:
        </p>

        <p className={styles.viewJD} onClick={handleViewJD}>View Job Description</p>
      </div>
      <PdfViewerModal
        isOpen={isPdfModalOpen}
        onClose={handleClosePdfModal}
        pdfFile={pdfFile}
      />
    </>

  );
};

export { UploadedJobDescription };
